













































































































import Vue from 'vue';
import approximateValue from '@/helpers/approximateValue';
import tableComponent from '@/components/TheTable.vue';
import titlePageComponent from '@/components/TheTitlePage.vue';
import SidebarRight from '@/components/TheSidebarRight.vue';
import IndicatorComponent from '@/components/InfoIndicator.vue';
import ChartJs from '@/components/Chart.vue';
import {
  requestNewOrder,
  requestTradeNow,
  requestConfirmTrade
} from '@/constants/sidebarData';
import { formatData } from '@/constants/commonContent';
import orderPdfMaker from '@/helpers/pdfmakers/order';
import PulseLoader from 'vue-spinner/src/PulseLoader.vue';
import Component from 'vue-class-component';
import { Base } from '@/base';

const FORMAT_DATE = formatData.dateTime;
const XDAI_NETWORK_ID = 100
@Component({
  name: 'MarketplacePage',
  components: {
    SidebarRight,
    tableComponent,
    titlePageComponent,
    PulseLoader,
    IndicatorComponent,
    ChartJs
  }
})
export default class MarketplacePage extends Base {
  btnText = 'New order';
  ordersTable = {
    titleText: '',
    titleBg: 'green-blue-title',
    sorted: 'id',
    columns: [
      { field: 'id', title: '#' },
      { field: 'status', title: 'STATUS' },
      { field: 'issued', title: 'ISSUED' },
      { field: 'amount', title: 'AMOUNT' },
      { field: 'price', title: 'PRICE PER SHARE' },
      { field: 'buySell', title: 'BUY/SELL' },
      { field: 'action', title: 'ACTION' }
      ],
    rows: []
  };
  pastOrdersTable = {
    titleText: 'PAST TRADES',
    titleBg: 'pink-title',
    sorted: 'id',
    columns: [
      { field: 'id', title: '#' },
      { field: 'status', title: 'SHAREHOLDER' },
      { field: 'issued', title: 'DATE' },
      { field: 'amount', title: 'AMOUNT' },
      { field: 'price', title: 'PRICE PER SHARE' },
      { field: 'buySell', title: 'BUY/SELL' },
      { field: 'action', title: 'ACTION' }
      ],
    rows: []
  };
  marketCupInfo = {
    title: 'MARKET CAP',
    value: '$0',
    value2: '0 ',
    color: 'gradient-1'
  };
  volumeInfo = {
    title: 'VOLUME (24h)',
    value: '$0',
    value2: '0 ',
    color: 'gradient-2'
  };
  hightInfo = {
    title: 'DAILY HIGH',
    value: '$0',
    color: 'gradient-3'
  };
  infoTotalSupplyObj = {
    title: 'TOTAL SUPPLY',
    value: 'No', // for example: 100,000,000 KORP
    color: 'gradient-1'
  };
  infoShareholdersObj: any = {
    title: 'SHAREHOLDERS',
    value: 'No', // for example: 23
    color: 'gradient-2'
  };

  // Computed
  get tokenBalance() {
    return this.getTokenBalance();
  }
  get isOrderPending() {
    return this.getPendings.ordering.new;
  }
  get isAgent() {
    return this.isReader;
  }
  get chartTitle() {
    return `${this.getTokenSymbol} chart`;
  }
  get tradePendingId() {
    return this.getPendings.trade.id;
  }
  get cancelOrderPendingId() {
    return this.getPendings.cancelOrder.id;
  }

  get isxDAiNetwork() {
    switch ( this.getNetwork ) {
      case null:
      case 100:
        return true
      default:
        false
    }

  }

  get approximatePrice() {
    if (this.getOneETHtoUSD) {
      return `Approximate cost for 1 ETH/hour = $ ${Number(
        (this.getEthToUSDPrice + this.getOneETHtoUSD) / 2
      ).toFixed(2)}`;
    }
    return '';
  }
  get ordersTableData() {
    let rows: any[] = [];
    let index = 0;
    for (let order of this.getActiveOrders) {
      if (order.isActive) {
        index += 1;
        let row: any = {};
        row.address = order.address;
        row.id = index;
        row.orderId = order.id;
        row.issued = this.$moment.unix(order.startTime).format(FORMAT_DATE);
        row.amount = formatData.number(order.remainder);
        row.fullAmount = formatData.number(order.amount);
        row.isOwner = order.address === this.getWallet;
        row.price = !this.isxDAiNetwork ?
          `ETH ${order.price} / $ ${+(order.price * approximateValue()).toFixed(5)}` : `$ ${order.price}`;
        row.orderPrice = order.price;
        row.buySell = order.mode === 1 ? 'Buy' : 'Sell';
        row.class = order.mode === 1 ? 'approved' : 'denied';
        row.status = 'Open';
        row.statusColor = 'green-circle';
        if (order.address === this.getWallet) {
          row.btnText = 'Cancel order';
          row.btnClass = 'btn btn-info cancel';
          row.btnAction = this.cancelOrder;
          row.btnPending = this.isCancelOrderPending;
          row.btnDisabled = this.isDisableCancelOrderButton;
        } else {
          row.btnText = 'Trade now';
          row.btnClass = 'btn btn-info';
          row.btnAction = this.requestTradeNow;
          row.btnPending = this.isTradePending;
          row.btnDisabled = this.isDisableTradeButton;
        }
        rows.push(row);
      }
    }
    Vue.set(this.ordersTable, 'rows', rows);
    return this.ordersTable;
  }
  get pastOrdersTableData() {
    let rows: any[] = [];
    let index = 0;
    for (let variable in this.getTrades) {
      let pastTrade = this.getTrades[variable];
      if (pastTrade.status === 3) {
        const order = this.getOrders[pastTrade.orderId] ? this.getOrders[pastTrade.orderId] : {};
        let row: any = {};
        index += 1;
        row.id = index;
        row.orderId = pastTrade.id;
        row.status = this.getMember(pastTrade.creator)
          ? this.getMember(pastTrade.creator).name
          : null;
        row.issued = this.$moment.unix(pastTrade.startTime).format(FORMAT_DATE);
        row.amount = formatData.number(pastTrade.amount);
        row.price = !this.isxDAiNetwork
          ? `ETH ${order.price} / $ ${+(order.price * approximateValue()).toFixed(5)}` : `$ ${order.price}`;
        row.buySell = order.mode === 2 ? 'Buy' : 'Sell';
        row.btnClass = order.mode === 2 ? 'approved' : 'denied';
        row.order = order;
        row.creator = pastTrade.creator;
        rows.push(row);
      }
    }
    Vue.set(this.pastOrdersTable, 'rows', rows);
    return this.pastOrdersTable;
  }
  get chartData() {
    return this.getChartData.length ? this.getChartData : [];
  }
  get getHightInfo() {
    Vue.set(this.hightInfo, 'value', formatData.toETHFormat(this.getDailyHigh.price || 0, 7, this.isxDAiNetwork));
    return this.hightInfo;
  }
  get getVolumeInfo() {
    Vue.set(this.volumeInfo, 'value', formatData.toETHFormat(this.getDailyVolume.price || 0, 7, this.isxDAiNetwork));
    Vue.set(
      this.volumeInfo,
      'value2',
      formatData.toTokenFormat(+this.getDailyVolume.shares || 0, this.getTokenInfo.symbol)
    );
    return this.volumeInfo;
  }
  get getMarketCupInfo() {
    const order = this.getOrders[this.getLastTrade.orderId];
    Vue.set(
      this.marketCupInfo,
      'value',
      order
        ? formatData.toETHFormat(order.price * this.getTokenInfo.totalSupply, 7, this.isxDAiNetwork)
        : formatData.toETHFormat(this.getTokenInfo.totalSuppl, 7, this.isxDAiNetwork)
    );
    Vue.set(
      this.marketCupInfo,
      'value2',
      formatData.toTokenFormat(this.getTokenInfo.totalSupply, this.getTokenInfo.symbol)
    );
    return this.marketCupInfo;
  }

  mounted() {
    this.ordersTable.titleText = this.getTokenInfo.symbol + ' ORDERS';
    this.getMarketCupExt();
    this.getDailyHighExt();
    this.getDailyVolumeExt();
  }

  destroyed() {
    this.clearChartData();
  }

  // Methods
  requestNewOrderData() {
    this.setSideBarForm(requestNewOrder(approximateValue(), this.isxDAiNetwork));
    this.openClose();
  }
  requestTradeNow(props) {
    this.setSideBarForm(requestTradeNow(props));
    this.openClose();
  }
  isCancelOrderPending(props) {
    return this.cancelOrderPendingId === props.orderId;
  }
  isTradePending(props) {
    return this.tradePendingId === props.orderId;
  }
  cancelOrder(props) {
    this.cancelMarketOrderDapp(props.orderId);
  }
  infoTotalSupply() {
    if (this.getTokenTotalSupply && this.getTokenSymbol) {
      this.infoTotalSupplyObj.value = this.getTokenTotalSupply + ' ' + this.getTokenSymbol;
    }
    return this.infoTotalSupplyObj;
  }
  infoShareholders() {
    if (this.getMemberCounter) {
      this.infoShareholdersObj.value = this.getMemberCounter;
    }
    return this.infoShareholdersObj;
  }
  downloadOrder(row) {
    const filename = this.getTokenInfo.symbol + '_trade_#' + row.id;
    let from;
    let to;
    if (row.buySell === 'Buy') {
      from = this.getMember(row.order.address).name;
      to = row.status;
    } else {
      from = row.status;
      to = this.getMember(row.order.address).name;
    }
    row.from = from;
    row.to = to;
    orderPdfMaker(row, this.getMember, this.getOwners).download(filename);
  }
  isDisableCancelOrderButton(props) {
    if (this.isUsedEscrow) {
      return !!this.getTradeTransfersEscrow.find(trade => trade.orderId === props.orderId);
    } else return false;
  }
  isDisableTradeButton(props) {
    return parseFloat(props.amount) === 0;
  }
  setChart(event) {
    this.getChartDataExt({
      from: this.$moment(event.from)
        .startOf('day')
        .unix(),
      to: this.$moment(event.to)
        .endOf('day')
        .unix()
    });
  }
};
